module.exports = __webpack_public_path__ + "img/2.a49a3bad.jpeg";